import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const { REACT_APP_CONTEXT_PATH, REACT_APP_ASSIST_API_URL, REACT_APP_ASSIST_API_TOKEN } = process.env;

// Initial state
const initialState = {
  channelTypeCd: null,
  channelId: null,
  userId: null,
  channelCd: null,
  branchId: null,
  branchName: null,
  brandId: null, // 이 내용으로 테마도 설정
  brandName: null,
  areaCode: null,
  status: null,
  loading: false,
  error: false,
  loaded: false,
  errorType: null,
  manualOperation: false,
};

// Slice
const checkArsStatusSlice = createSlice({
  name: "checkArsStatus",
  initialState,
  reducers: {
    reqArsStatus(state) {
      return { ...state, loading: true, error: false, loaded: false };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setInitData(state, action) {
      const {
        channelTypeCd,
        channelId,
        userId,
        channelCd,
        branchId,
        branchName,
        brandId,
        brandName,
        areaCode,
        manualOperation,
      } = action.payload;
      return {
        ...state,
        channelTypeCd,
        channelId,
        userId,
        channelCd,
        branchId,
        branchName,
        brandId,
        brandName,
        areaCode,
        manualOperation,
      };
    },
    setStatus(state, action) {
      const { status, errorType } = action.payload;
      return {
        ...state,
        status,
        errorType,
      };
    },
    setInit(state) {
      return {
        ...state,
        channelId: null,
        userId: null,
        channelCd: null,
        channelTypeCd: null,
        branchId: null,
        branchName: null,
        brandId: null,
        brandName: null,
        areaCode: null,
        status: null,
        loading: false,
        error: false,
        loaded: false,
        errorType: null,  
        manualOperation: false,
      };
    },
  },
});

export const {
  reqArsStatus,
  fetchDataSuccess,
  fetchDataFailure,
  setInitData,
  setStatus,
  setInit,
} = checkArsStatusSlice.actions;

export default checkArsStatusSlice.reducer;

function* fetchDataSaga(action) {
  const tempUserId = yield select((state) => state.parseUrl.userId);
  const userId = tempUserId??"".replaceAll(" ", "+");

  const channelId = yield select((state) => state.parseUrl.channelId);
  const { headers = {}, apiUrl, data = {} } = action.payload;

  const peerIpApiService = axios.create({
    headers: {
      emquest_access_token: REACT_APP_ASSIST_API_TOKEN,
    },
    timeout: 10000,
    baseURL: REACT_APP_ASSIST_API_URL + `/system/ip`,
  });

  try {
    const response = yield call(peerIpApiService.get);
    const { data: { x_forwarded_for } } = response.data;

    const apiService = axios.create({
      headers: {
        user_ip: x_forwarded_for
      },
      timeout: 10000,
      baseURL: REACT_APP_CONTEXT_PATH,
    });

    try {
      const arsStatus = yield call(apiService.post, apiUrl, data); //ars 상태 확인
      const { data: arsStatusData } = arsStatus;

      if (arsStatus?.data?.code === "0000") {
        yield put(fetchDataSuccess(arsStatusData.data));
        if (arsStatusData?.data[0]?.infloChnlId) {
          const data = arsStatusData.data[0];
          const {
            cbotInfloTypeCd: channelTypeCd,
            cbotInfloChnlCd: channelCd,
            emartBranchId: branchId,
            emartBranchName: branchName,
            brandId: brandId,
            brandNm: brandName,
            areaCode,
          } = data;

          yield put(
            setInitData({
              userId,
              channelTypeCd,
              channelId,
              channelCd,
              branchId,
              branchName,
              brandId,
              brandName,
              areaCode,
              manualOperation: false,
            })
          );
          if (brandId) {
            localStorage.setItem("selected-brand", brandId);
            document.documentElement.setAttribute("data-theme", brandId);
          }
          yield put(setStatus({ status: "available" }));
          return;
        } else {
          yield put(setStatus({ status: "expired" }));
          return;
        }
      } else if (arsStatus?.data?.code === "0307") {
        yield put(fetchDataSuccess(arsStatusData.data));
        if (arsStatusData?.data[0]?.infloChnlId) {
          const data = arsStatusData.data[0];
          const {
            cbotInfloTypeCd: channelTypeCd,
            cbotInfloChnlCd: channelCd,
            emartBranchId: branchId,
            emartBranchName: branchName,
            brandId: brandId,
            brandNm: brandName,
            areaCode,
          } = data;

          yield put(
            setInitData({
              userId,
              channelTypeCd,
              channelId,
              channelCd,
              branchId,
              branchName,
              brandId,
              brandName,
              areaCode,
              manualOperation: true,
            })
          );
          if (brandId) {
            localStorage.setItem("selected-brand", brandId);
            document.documentElement.setAttribute("data-theme", brandId);
          }
          yield put(setStatus({ status: "available" }));
          return;
        } else {
          yield put(setStatus({ status: "expired" }));
          return;
        }
      } 
      
    } catch (error) {
      yield put(fetchDataFailure(error));
      yield put(setStatus({ status: "expired" }));
      return;
    }

  } catch (error) {
    yield put(fetchDataFailure(error));
    return;
  }

}

// API 호출을 감시하는 Saga 함수
export function* checkArsStatusSaga() {
  yield takeLatest(reqArsStatus.type, fetchDataSaga);
}
